import React from 'react'
import { Link } from 'react-router-dom'

const CategoryList = props => {
  if (!props.data) {
    return (
      <div className={'LoadingPane'}>Loading...</div>
    )
  }

  if (props.data.length === 0) {
    return (
      <div>
        No products...
      </div>
    )
  }

  return (
    <ul className="DataList ProductList">
      {
        props.data.map(item => {
          return (
            <li key={item.key}>
              <strong>{item.name}</strong>
              {
                (props.mode === 'edit') ?
                  <Link to={`/category/edit/${item.key}`}><i className="icon ion-md-more"></i></Link>
                  :
                  <i className="icon ion-ios-add-circle-outline"></i>
              }
            </li>
          )
        })
      }
    </ul>
  )
}

export default CategoryList
